'use client';

import { countryFlagEmoji } from '@plura/shared/utils';
import { getCountryName } from './getCountryName';

export function getCountryString(countryCode: string) {
  return `${countryFlagEmoji(getCountryName(countryCode))} ${getCountryName(
    countryCode
  )}`;
}
